module.exports = __webpack_public_path__ + "img/img-process2@2x.559b6432.jpg";